import type { ReactNode } from "react";

import styled from "styled-components";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { TeaserBanner } from "app/components/banner/TeaserBanner";
import { translate } from "app/filters/i18nFilter";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { CampaignsBannerWrapper } from "./CampaignsBannerStyledComponents";

interface ICampaignsBannerProps {
    title: ReactNode;
    subtitle?: string;
    buttonText?: string;
    onButtonClick?: VoidFunction;
    CustomIcon?: React.ReactNode;
    buttonIconName?: IconName;
    enabledTooltip?: boolean;
    tooltipContentKey?: string;
}

const BannerTitle = styled(FlexRow)`
    .SWReactIcons:last-child {
        svg {
            path {
                fill: ${colorsPalettes.carbon["200"]} !important;
            }
        }
    }
`;
const IconsWrapper = styled(CenteredFlexRow)``;
const TitleTextWrapper = styled.span`
    margin-right: 8px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
`;
export const CampaignsBanner = (props: ICampaignsBannerProps) => {
    const {
        CustomIcon,
        buttonIconName,
        onButtonClick,
        title,
        subtitle,
        buttonText,
        enabledTooltip = true,
        tooltipContentKey = "campaigns.banner.balance.title.tooltip",
    } = props;

    const getTitle = () => {
        return (
            <BannerTitle>
                <TitleTextWrapper>{title}</TitleTextWrapper>
                {enabledTooltip ? (
                    <PlainTooltip tooltipContent={translate(tooltipContentKey)}>
                        <IconsWrapper>
                            <SWReactIcons
                                size="xs"
                                iconName="info-full"
                                iconColor={colorsPalettes.carbon["200"]}
                            />
                        </IconsWrapper>
                    </PlainTooltip>
                ) : null}
            </BannerTitle>
        );
    };
    return (
        <CampaignsBannerWrapper>
            <TeaserBanner
                title={getTitle()}
                subtitle={subtitle}
                CustomIcon={CustomIcon}
                buttonText={buttonText}
                buttonType="flat"
                buttonIconName={buttonIconName}
                onButtonClick={onButtonClick}
            />
        </CampaignsBannerWrapper>
    );
};
